import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { PieceIcon } from './Pieces';

/** "Other games": a switcher between IllegalChess, War Royale and Life in the Hood, top right of every page. */
export function OtherGames({ className = '' }: { className?: string }) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const path = useLocation().pathname;
  const here = path.startsWith('/war') ? 'war' : path.startsWith('/hood') ? 'hood' : 'chess';

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const go = (to: string) => { setOpen(false); nav(to); };

  return (
    <>
      <button type="button" className={`other-games-btn ${className}`} onClick={() => setOpen(true)} aria-haspopup="dialog">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
        Other games
      </button>
      {open && createPortal(
        <div className="modal-backdrop" role="presentation" onClick={() => setOpen(false)}>
          <div className="games-modal card" role="dialog" aria-modal="true" aria-label="Choose a game" onClick={(e) => e.stopPropagation()}>
            <h2>Choose a game</h2>
            <div className="games-grid">
              <button type="button" className={`game-tile chess ${here === 'chess' ? 'on' : ''}`} onClick={() => go('/')}>
                <span className="game-art"><PieceIcon icon="dragon" color="w" set="classic" /><PieceIcon icon="king" color="b" set="classic" /></span>
                <b>IllegalChess</b>
                <span>Chess with every rule unlocked</span>
                {here === 'chess' && <em>You are here</em>}
              </button>
              <button type="button" className={`game-tile war ${here === 'war' ? 'on' : ''}`} onClick={() => go('/war')}>
                <span className="game-art"><i className="war-logo-mark" /></span>
                <b>WAR ROYALE</b>
                <span>Real-time military card battles</span>
                {here === 'war' && <em>You are here</em>}
              </button>
              <button type="button" className={`game-tile hood ${here === 'hood' ? 'on' : ''}`} onClick={() => go('/hood')}>
                <span className="game-art"><i className="hood-logo-mark" /></span>
                <b>LIFE IN THE HOOD</b>
                <span>Online open-world city sandbox</span>
                {here === 'hood' && <em>You are here</em>}
              </button>
            </div>
            <button type="button" className="btn ghost" onClick={() => setOpen(false)}>Close</button>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
